import { render, staticRenderFns } from "./GameTableHeader.vue?vue&type=template&id=4015216a&scoped=true"
import script from "./GameTableHeader.vue?vue&type=script&lang=js"
export * from "./GameTableHeader.vue?vue&type=script&lang=js"
import style0 from "./GameTableHeader.vue?vue&type=style&index=0&id=4015216a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4015216a",
  null
  
)

export default component.exports